import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase config is supplied by REACT_APP_FIREBASE_* environment variables.
// See .env.example for setup.
//
// There is deliberately NO fallback to hard-coded production values. A missing
// or partial config must fail loudly at startup rather than silently connecting
// a preview or local build to the live learner database.
//
// Note: Create React App inlines these at BUILD time, so changing them requires
// a rebuild, not just a redeploy.
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const missing = Object.keys(firebaseConfig).filter((k) => !firebaseConfig[k]);

if (missing.length > 0) {
  throw new Error(
    "Firebase configuration is incomplete. Missing: " +
      missing.join(", ") +
      ". Copy .env.example to .env.local and fill in the values, or set the " +
      "REACT_APP_FIREBASE_* variables in your Vercel environment. " +
      "Refusing to start rather than risk connecting to the wrong project."
  );
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Surfaced so the active project can be confirmed from the browser console
// before running any test against a preview or staging build.
export const activeProjectId = firebaseConfig.projectId;
